import { render, staticRenderFns } from "./GacetaIndex.vue?vue&type=template&id=0a0fd27a&"
import script from "./GacetaIndex.vue?vue&type=script&lang=js&"
export * from "./GacetaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports